import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { formatPhoneNumber } from '../../../utils/user';
import DetailItem from './DetailItem/DetailItem';
import { IUserEditState } from './utils';
import CustomAccordion from '../../../common/components/CustomAccordion/CustomAccordion';
import { CIVILITIES, Civility } from '../../../common/constants';

interface Params {
  userState: IUserEditState;
  setUserState: React.Dispatch<React.SetStateAction<IUserEditState>>;
  canEditUser: boolean;
}

const UserCoordonnees: FC<Params> = (props) => {
  const { userState, setUserState, canEditUser } = props;

  return (
    <CustomAccordion title="Coordonnées">
      <Grid container>
        <DetailItem<IUserEditState>
          select
          mutationVariableName="civility"
          name="Civilité"
          value={userState.civility}
          options={Object.values(Civility)}
          labelAccessor={(civility) => CIVILITIES[civility as Civility]}
          editable={canEditUser}
          setUserState={setUserState}
        />
        <DetailItem<IUserEditState>
          mutationVariableName="lastName"
          name="Nom"
          value={userState.lastName}
          editable={canEditUser}
          setUserState={setUserState}
        />
        <DetailItem<IUserEditState>
          mutationVariableName="firstName"
          name="Prénom"
          value={userState.firstName}
          editable={canEditUser}
          setUserState={setUserState}
        />
        <DetailItem<IUserEditState>
          mutationVariableName="phone"
          name="Téléphone"
          value={formatPhoneNumber(userState.phone)}
          setUserState={setUserState}
          editable={canEditUser}
        />
        <DetailItem<IUserEditState>
          mutationVariableName="email"
          name="Email"
          value={userState.email}
          setUserState={setUserState}
          editable={canEditUser}
        />
      </Grid>
    </CustomAccordion>
  );
};

export default UserCoordonnees;
